import { FEATURE_ENUM } from '@partoohub/api-client';

import { useMe } from 'app/pages/app/AppDataProvider/hooks/useMe';

/**
 * Return if the user has access to a feature
 */
export const useHasFeature = (feature: FEATURE_ENUM): boolean => {
    const me = useMe();
    return me.available_features?.includes(feature) ?? false;
};
